// extracted by mini-css-extract-plugin
module.exports = {"hasForm":"SectionEvent_hasForm__LPfBp","form":"SectionEvent_form___x8Rp"};